export const version = "strings/5.6.1";
